<div *ngIf="steps">
    <div class="timelineframe primarybackground50">
        <div class="barwrapper primarybackground500" [style.width.%]="BarPercent"></div>
        <div *ngFor="let twidth of ticks; let idx = index" class="timelinemarker" [style.left]="('calc(' + twidth + '% - 7.5px)')" [title]="steps[idx]?.Tooltip">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"><circle cx="5" cy="5" r="5" style="fill:white;stroke:black;stroke-width:0.5" /></svg>
        </div>
    </div>
    <div class="padtop" *ngIf="steps && steps[currentStep]"><strong>Right now:</strong> {{steps[currentStep]?.Description}}</div>
    <div *ngIf="steps && steps[currentStep] && steps[currentStep].NextStep"><strong>What to do next:</strong> {{steps[currentStep].NextStep}}</div>
    <div *ngIf="steps && steps[currentStep] && steps[currentStep].Warning"><span [innerHTML]="steps[currentStep].Warning | safeHTML"></span></div>
</div>


// WEBPACK FOOTER //
// ./src/app/ui/timeline/timeline.component.html